<template>
  <header>
    <Logo @click='showMenu=0' />
    <MenuNavigation :show='showMenu'/>
    <MenuToggle :open='showMenu' @click='showMenu+=(showMenu > 0) ? -1 : 1' />
  </header>
</template>

<script setup>
import { composables } from '@/composables'
const showMenu = composables().showMenu;
</script>

<style scoped>
  header {
    position: absolute;
    display: flex;
    justify-content: space-between;
    width: var(--main-width-narrow);
    left: 0;
    right: 0;
    margin: auto;
    z-index: 2;
    padding: var(--header-padding);
  }
</style>
